import Header from './Header';
import Menu from './Menu';
import ContactForm from './ContactForm';
import Footer from './Footer';
import CTA from './CTA';
import MoreCaseStudies from './MoreCaseStudies';
import Testimonials from './Testimonials';
import ClientLogos from './ClientLogos';

export { Header, Menu, ContactForm, Footer, CTA, MoreCaseStudies, Testimonials, ClientLogos }


// WEBPACK FOOTER //
// ./client/components/index.js